import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Layout from "src/features/Layout";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { fetchDetail } from "../ducks";

import Detail from "./detail";
import AddPromo from "./addPromo";
import Price from "./price";
import Timeline from "./timeline";

const useStyles = makeStyles((theme) => ({
  title: { marginBottom: theme.spacing(2) },
}));

function Index() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const _id = useSelector((state) => state.router.location.pathname).split(
    "/"
  )[2];

  useEffect(() => {
    dispatch(fetchDetail(_id));
    return () => {};
  }, [dispatch, _id]);

  return (
    <Layout
      breadcrumbs={{
        previous: [{ href: "/medicine", name: "Home" }],
        current: "Promotion Management",
      }}
    >
      <Typography variant="h5" className={classes.title}>
        Medicine Promotion
      </Typography>
      <Detail />
      <Grid container spacing={2}>
        <Grid item md={12} lg={10}>
          <AddPromo />
        </Grid>
        <Grid item md={12} lg={2}>
          <Price />
        </Grid>
      </Grid>
      <Timeline />
    </Layout>
  );
}

export default Index;
